import {field, identifier, LocalisableEntityData, transientField} from "@fedeltapointofsale/data-client";

export class ProductLineReferenceData extends LocalisableEntityData<ProductLineReferenceData> {
    sellableType: string = "ProductLineData";
    @identifier sellableId: number;
    @field name: string;
    @field discontinued: boolean;
}
